import React, {useEffect, useState} from 'react';
import Layout from "../../components/Layout";
import {Table} from "react-bootstrap";
import axios from "axios";

const Requests = () => {
    const [list, setList] = useState([])

    useEffect(() =>{
        axios('https://613af3f5110e000017a453df.mockapi.io/modal')
            .then(({data}) => setList(data))
    },[])
    
    const deleteList = (id) => {
      axios.delete(`https://613af3f5110e000017a453df.mockapi.io/modal/${id}`)
          .then(({data}) => setList(list.filter(el => el.id !== id)))
    }
    return (
        <Layout>
            <Table striped bordered hover variant="dark">
                <thead>
                <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Email</th>
                </tr>
                </thead>
                <tbody>
                {
                    list.map((item, idx) =>
                        <tr id={item.id} onClick={() => deleteList(item.id)}>
                            <td>{idx + 1}</td>
                            <td>{item.name}</td>
                            <td>{item.phone}</td>
                            <td>{item.email}</td>
                        </tr>
                    )
                }
                </tbody>
            </Table>
        </Layout>
    );
};

export default Requests;